import { minSize, DEVICE_SIZES } from 'rn-responsive-styles';

const isDeviceMinimumSize = (deviceSize: DEVICE_SIZES, minimumSize: DEVICE_SIZES) => {
	const largerBreakpoints = minSize(minimumSize).split('+');
	if (largerBreakpoints.length < 1) {
		return false;
	}

	return largerBreakpoints.includes(deviceSize);
};

export { isDeviceMinimumSize };
